import Input                          from 'antd/es/input';
import type { SearchProps }           from 'antd/es/input';
import { injectIntl }                 from 'react-intl';
import type { WrappedComponentProps } from 'react-intl';

const { Search } = Input;

interface IntlSearchProps extends SearchProps, WrappedComponentProps {
  placeholder?: any;
}

const IntlSearch = (props: IntlSearchProps) => {
  const allProps = {
    ...props,
  };

  if (props.placeholder) {
    allProps.placeholder = props.intl.formatMessage({
      id: props.placeholder || ' ',
    });
  }

  return <Search {...allProps} />;
};

export default injectIntl(IntlSearch);
